import { StyleSheet, View } from 'react-native';

import { Skeleton, tokens } from '@fhs/ui';

export function MenuListSkeleton() {
  return (
    <View style={styles.container}>
      <View style={styles.tabs}>
        {[110, 118, 130].map((width, index) => (
          <View key={width} style={[styles.tab, index === 0 && styles.activeTab]}>
            <Skeleton style={{ width, height: 16, borderRadius: 8 }} />
          </View>
        ))}
      </View>
      <View style={styles.content}>
        <View style={styles.offersTile}>
          <Skeleton style={styles.offersIcon} />
          <Skeleton style={styles.offersText} />
        </View>
        <Skeleton style={styles.sectionTitle} />
        {Array.from({ length: 5 }, (_, index) => (
          <View key={index} style={styles.item}>
            <Skeleton style={styles.itemImage} />
            <View style={styles.itemText}>
              <Skeleton style={styles.itemTitle} />
              <Skeleton style={styles.itemDescription} />
              <Skeleton style={styles.itemDescriptionShort} />
            </View>
          </View>
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    overflow: 'hidden',
    backgroundColor: tokens.colors.$white,
  },
  tabs: {
    height: 44,
    flexDirection: 'row',
  },
  tab: {
    paddingHorizontal: 16,
    paddingBottom: 12,
    justifyContent: 'flex-end',
    borderBottomWidth: 3,
    borderBottomColor: tokens.colors.$blackOpacity10,
  },
  activeTab: {
    borderBottomColor: tokens.colors.$houseRed,
  },
  content: {
    padding: 16,
    paddingTop: 24,
    gap: 16,
  },
  offersTile: {
    height: 56,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 16,
    paddingHorizontal: 16,
    borderWidth: 1,
    borderRadius: 8,
    borderColor: tokens.colors.$blackOpacity10,
  },
  offersIcon: {
    width: 30,
    height: 30,
    borderRadius: 15,
  },
  offersText: {
    width: 180,
    height: 20,
    borderRadius: 10,
  },
  sectionTitle: {
    width: 170,
    height: 25,
    borderRadius: 12,
    marginTop: 8,
    marginBottom: 8,
  },
  item: {
    height: 90,
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  itemImage: {
    width: 132,
    height: 90,
    borderRadius: 8,
  },
  itemText: {
    flex: 1,
    gap: 4,
  },
  itemTitle: {
    width: '78%',
    height: 20,
    borderRadius: 10,
  },
  itemDescription: {
    width: '100%',
    height: 12,
    borderRadius: 6,
  },
  itemDescriptionShort: {
    width: '72%',
    height: 12,
    borderRadius: 6,
  },
});
